// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b34ec280","184":"9ebf6117","232":"76771e6c","316":"90af8f02","408":"c3b66911","476":"a67bfd55","500":"68e512f0","551":"ffac6e8a","560":"f6596b3f","628":"66f3e939","736":"a332db14","808":"f9db4f68","836":"00e960cc","932":"ab42a71b","952":"295f5d4d","980":"9a2bc259"}[chunkId] + ".chunk.js";
};